<template>
  <sub-page :title="title">
    <div class="labor-page">
      <!-- 顶部蓝色横幅 -->
      <div class="banner">
        <div class="banner-badge">
          <img :src="badgeIcon" class="badge-img" alt="劳动监察" />
        </div>
        <div class="banner-title">劳动权益保障</div>
        <div class="banner-desc">保障农民工权益・规范工资支付・构建和谐劳动关系</div>
        <div class="banner-tags">
          <div class="tag">
            <svg viewBox="0 0 24 24" class="tag-icon"><path d="M20 6L9 17l-5-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span>实时监管</span>
          </div>
          <div class="tag">
            <svg viewBox="0 0 24 24" class="tag-icon"><rect x="3" y="4" width="18" height="16" rx="2" fill="none" stroke="#fff" stroke-width="2"/><path d="M8 10h8M8 14h5" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>
            <span>工资保障</span>
          </div>
          <div class="tag">
            <svg viewBox="0 0 24 24" class="tag-icon"><circle cx="12" cy="8" r="4" fill="none" stroke="#fff" stroke-width="2"/><path d="M6 21v-1a6 6 0 0112 0v1" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>
            <span>权益维护</span>
          </div>
        </div>
      </div>

      <!-- 提示条 -->
      <div class="tip-bar">
        <span>点击下方按钮进入对应分区页面</span>
        <svg viewBox="0 0 24 24" class="tip-close" @click="closeTip"><path d="M18 6L6 18M6 6l12 12" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>
      </div>

      <!-- 举报投诉渠道横幅 -->
      <div class="channel-banner">
        <span>全省劳动保障监察举报投诉维权渠道</span>
      </div>

      <!-- 功能按钮网格 -->
      <div class="grid-section">
        <div class="grid-row">
          <div class="grid-item blue" @click="handleClick('农民工工资监管')">
            <div class="grid-icon">
              <img :src="wageIcon" class="icon-img" alt="工资监管" />
            </div>
            <span class="grid-text">农民工工资监管</span>
          </div>
          <div class="grid-item orange" @click="handleClick('举报投诉')">
            <div class="grid-icon">
              <img :src="complaintIcon" class="icon-img" alt="举报投诉" />
            </div>
            <span class="grid-text">举报投诉</span>
          </div>
        </div>
        <div class="grid-row">
          <div class="grid-item purple" @click="handleClick('欠薪线索')">
            <div class="grid-icon">
              <img :src="clueIcon" class="icon-img" alt="欠薪线索" />
            </div>
            <span class="grid-text">欠薪线索</span>
          </div>
          <div class="grid-item green" @click="handleClick('书面审查')">
            <div class="grid-icon">
              <img :src="reviewIcon" class="icon-img" alt="书面审查" />
            </div>
            <span class="grid-text">书面审查</span>
          </div>
        </div>
        <div class="grid-row single">
          <div class="grid-item dark-blue" @click="handleClick('企业诚信')">
            <div class="grid-icon">
              <svg viewBox="0 0 24 24" class="icon-svg"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 12l2 2 4-4" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <span class="grid-text">企业诚信</span>
          </div>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'LaborRights',
  components: { SubPage },
  data() {
    return {
      title: '劳动权益保障',
      badgeIcon: require('@/assets/icons/svc-labor-badge.png'),
      wageIcon: require('@/assets/icons/svc-labor-wage.png'),
      complaintIcon: require('@/assets/icons/svc-labor-complaint.png'),
      clueIcon: require('@/assets/icons/svc-labor-clue.png'),
      reviewIcon: require('@/assets/icons/svc-labor-review.png')
    }
  },
  methods: {
    closeTip() {
      // 关闭提示条
    },
    // 各分区跳转对应业务页（农民工工资监管→工资核算、举报投诉→投诉登记、
    // 欠薪线索→线索反映、书面审查→案件查询、企业诚信→项目履历）
    handleClick(name) {
      const routeMap = {
        农民工工资监管: '/migrant-wage-calc',
        举报投诉: '/labor-complaint',
        欠薪线索: '/wage-clue-report',
        书面审查: '/labor-case-query',
        企业诚信: '/project-history-query'
      }
      this.$router.push(routeMap[name] || '/labor-case-query')
    }
  }
}
</script>

<style scoped>
.labor-page {
  background: #F3F8FB;
  min-height: 100%;
}
.banner {
  background: linear-gradient(135deg, #3B7CFF 0%, #2E8CF6 100%);
  padding: calc(40 * var(--w)) calc(32 * var(--w)) calc(32 * var(--w));
  text-align: center;
  color: #fff;
}
.banner-badge {
  margin-bottom: calc(16 * var(--w));
}
.badge-img {
  width: calc(80 * var(--w));
  height: calc(80 * var(--w));
  object-fit: contain;
}
.banner-title {
  font-size: calc(40 * var(--w));
  font-weight: 600;
  margin-bottom: calc(12 * var(--w));
}
.banner-desc {
  font-size: calc(24 * var(--w));
  opacity: 0.9;
  margin-bottom: calc(24 * var(--w));
}
.banner-tags {
  display: flex;
  justify-content: center;
  gap: calc(32 * var(--w));
}
.tag {
  display: flex;
  align-items: center;
  gap: calc(8 * var(--w));
  font-size: calc(24 * var(--w));
}
.tag-icon {
  width: calc(24 * var(--w));
  height: calc(24 * var(--w));
}
.tip-bar {
  background: #2E8CF6;
  color: #fff;
  font-size: calc(24 * var(--w));
  padding: calc(16 * var(--w)) calc(32 * var(--w));
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tip-close {
  width: calc(24 * var(--w));
  height: calc(24 * var(--w));
  cursor: pointer;
}
.channel-banner {
  background: linear-gradient(135deg, #E74C3C 0%, #C0392B 100%);
  color: #fff;
  font-size: calc(28 * var(--w));
  text-align: center;
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.grid-section {
  padding: calc(24 * var(--w));
}
.grid-row {
  display: flex;
  gap: calc(24 * var(--w));
  margin-bottom: calc(24 * var(--w));
}
.grid-row.single {
  justify-content: flex-start;
}
.grid-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: calc(40 * var(--w)) calc(24 * var(--w));
  border-radius: calc(16 * var(--w));
  cursor: pointer;
}
.grid-item.blue {
  background: linear-gradient(135deg, #3498DB 0%, #2980B9 100%);
}
.grid-item.orange {
  background: linear-gradient(135deg, #E67E22 0%, #D35400 100%);
}
.grid-item.purple {
  background: linear-gradient(135deg, #9B59B6 0%, #8E44AD 100%);
}
.grid-item.green {
  background: linear-gradient(135deg, #2ECC71 0%, #27AE60 100%);
}
.grid-item.dark-blue {
  background: linear-gradient(135deg, #34495E 0%, #2C3E50 100%);
  max-width: calc(50% - 12 * var(--w));
}
.grid-icon {
  margin-bottom: calc(16 * var(--w));
}
.icon-img {
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  object-fit: contain;
}
.icon-svg {
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
}
.grid-text {
  color: #fff;
  font-size: calc(28 * var(--w));
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/LaborRights.vue